import axios from 'axios';
import { advertizerApiHost } from '../../constants/envs';
import { ILeadRepository, LeadListResult } from '../../application/ports/ILeadRepository';
import { LeadEntity } from '../../domain/entities/Lead';
import { mapApiToEntity } from '../mappers/leads.mapper';
import { AuthTokenProvider } from '../auth/AuthTokenProvider';

export class LeadsAxiosRepository implements ILeadRepository {
  constructor(private auth: AuthTokenProvider) {}

  private async authHeaders() {
    const token = await this.auth.getToken();
    if (!token) throw new Error('Unauthenticated');
    return { Authorization: `Bearer ${token}` };
  }

  async list(params?: { page?: number; perPage?: number }): Promise<LeadListResult> {
    const headers = await this.authHeaders();
    const res = await axios.get(`${advertizerApiHost}/api/admin/leads`, {
      params: { page: params?.page, perPage: params?.perPage },
      headers
    });
    return {
      items: (res.data.leads || []).map(mapApiToEntity),
      page: res.data.pagination?.page ?? params?.page ?? 1,
      perPage: res.data.pagination?.perPage ?? params?.perPage ?? 10,
      total: res.data.pagination?.total ?? 0,
    };
  }

  async process(id: number, isTarget: boolean): Promise<void> {
    const headers = await this.authHeaders();
    await axios.post(`${advertizerApiHost}/api/admin/leads/${id}/process`, { isConfirmed: true, isTarget }, { headers });
  }
}